/* GENERADO por scripts/sn-generar-shopify.py. Une los 2 scripts de la landing. No se edita aquí: se edita src/. */

/* ═══ assets/js/sn-landing.js ═══ */
/* sn-landing.js — interfaz de la landing. Vanilla, sin dependencias, sin build.
 *
 * Invariante: el estado en reposo es el estado final. Sin JS la página se ve
 * completa y el contenido legal y el precio nunca dependen de este archivo.
 * Los datos de la promoción salen del bloque JSON #sn-ajustes del HTML, que en
 * Shopify se vuelve settings de la sección.
 *
 * En el editor de temas de Shopify, cada cambio de ajuste vuelve a pintar la
 * sección sin ejecutar sus <script>: por eso todo se monta en montar(), que
 * primero deshace lo de la vez anterior (intervalos, oyentes de window,
 * observadores) y se repite en el evento shopify:section:load.
 */
(function () {
  "use strict";

  const QUIETO = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let raiz = null;
  let A = {};
  let limpiezas = [];
  const alLimpiar = (fn) => { limpiezas.push(fn); };

  function leerAjustes() {
    const nodo = document.getElementById("sn-ajustes");
    if (!nodo) return {};
    try { return JSON.parse(nodo.textContent); } catch (e) { return {}; }
  }

  function emitir(nombre, datos) {
    const detalle = datos || {};
    document.dispatchEvent(new CustomEvent("sn:" + nombre, { detail: detalle }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: nombre }, detalle));
  }

  /* ── Promoción cerrada: fecha vencida o 0 unidades ───────────────────
     Art. 29 Ley 1480: lo anunciado obliga. Al cerrarse, sale todo lo que
     anuncia la promoción (.sn-solo-promo). En Shopify lo decide Liquid con
     el precio y el inventario reales; esto es el respaldo del lado cliente. */
  function cerrarPromo() { raiz.classList.add("sn-promo-cerrada"); }

  /* ── Unidades y fecha de la promoción ──────────────────────────────── */
  function pintarPromo() {
    const finMs = new Date(A.fin_promo).getTime();
    const sinDescuento = Number.isFinite(A.precio) && Number.isFinite(A.precio_antes) && A.precio_antes <= A.precio;
    if (A.unidades_restantes === 0 || sinDescuento || (!isNaN(finMs) && Date.now() >= finMs)) cerrarPromo();
    if (Number.isInteger(A.unidades_restantes)) {
      document.querySelectorAll("[data-sn-unidades]").forEach((n) => { n.textContent = String(A.unidades_restantes); });
    } else {
      /* Sin cifra real de unidades no se dice "Quedan N" en ninguna parte. */
      raiz.classList.add("sn-sin-unidades");
    }
    const fin = new Date(A.fin_promo);
    if (!isNaN(fin)) {
      const txt = fin.toLocaleDateString("es-CO", { day: "numeric", month: "long", year: "numeric", timeZone: "America/Bogota" });
      document.querySelectorAll("[data-sn-promo-fecha]").forEach((n) => { n.textContent = txt; });
    }
  }

  /* ── Contador ─────────────────────────────────────────────────────────
     Art. 33 Ley 1480 de 2011: el plazo anunciado se respeta. El contador
     NUNCA se reinicia; al vencer, se oculta. */
  function arrancarReloj() {
    const bloques = document.querySelectorAll("[data-sn-reloj]");
    const fin = new Date(A.fin_promo).getTime();
    if (!bloques.length || isNaN(fin)) return;
    const dos = (n) => (n < 10 ? "0" + n : String(n));
    let id = 0;
    /* Con movimiento reducido no hay segundos corriendo: se ocultan sus
       celdas y el contador se actualiza cada minuto. */
    if (QUIETO) {
      document.querySelectorAll("[data-sn-seg]").forEach((n) => {
        const celda = n.closest(".sn-reloj__celda") || n;
        celda.hidden = true;
      });
    }

    function tick() {
      const resta = fin - Date.now();
      if (resta <= 0) {
        bloques.forEach((b) => { b.hidden = true; });
        cerrarPromo();
        clearInterval(id);
        return;
      }
      const s = Math.floor(resta / 1000);
      const valores = {
        dias: String(Math.floor(s / 86400)),
        horas: dos(Math.floor(s / 3600) % 24),
        min: dos(Math.floor(s / 60) % 60),
        seg: dos(s % 60),
      };
      bloques.forEach((b) => {
        Object.keys(valores).forEach((k) => {
          const celda = b.querySelector("[data-sn-" + k + "]");
          if (celda && celda.textContent !== valores[k]) celda.textContent = valores[k];
        });
      });
    }
    tick();
    id = setInterval(tick, QUIETO ? 60000 : 1000);
    alLimpiar(() => clearInterval(id));
  }

  /* ── Galería: avance automático, miniaturas, flechas, deslizar, teclado ─
     El avance lo marca el fin de la animación "sn-progreso" de la barra de
     la foto activa (::after de su miniatura). Así la pausa es una sola cosa:
     animation-play-state en CSS. Se detiene con el botón (WCAG 2.2.2), con el
     puntero o el foco dentro, y fuera de pantalla. Con movimiento reducido no
     hay avance automático ni acercamiento: fotos fijas que se cambian a mano. */
  function galeria() {
    const g = document.querySelector("[data-sn-galeria]");
    if (!g) return;
    const fotos = g.querySelectorAll("[data-sn-foto]");
    const minis = g.querySelectorAll("[data-sn-miniatura]");
    const escenario = g.querySelector(".sn-galeria__escenario");
    const pausa = g.querySelector("[data-sn-galeria-pausa]");
    let actual = 0;
    const motivos = { boton: false, puntero: false, foco: false, fuera: false };

    function ir(i) {
      /* La foto que sale conserva su acercamiento mientras se funde; si no,
         saltaría a escala 1 a la vista. */
      const saliente = fotos[actual] && fotos[actual].querySelector(".sn-galeria__img");
      if (saliente && !QUIETO) {
        saliente.style.transform = getComputedStyle(saliente).transform;
        setTimeout(() => { saliente.style.transform = ""; }, 720);
      }
      actual = (i + fotos.length) % fotos.length;
      fotos.forEach((f, k) => f.classList.toggle("sn-activa", k === actual));
      minis.forEach((m, k) => {
        m.classList.toggle("sn-activa", k === actual);
        m.classList.toggle("sn-vista", k < actual);
        m.setAttribute("aria-pressed", k === actual ? "true" : "false");
      });
      emitir("galeria_foto", { foto: actual + 1 });
    }

    minis.forEach((m, k) => m.addEventListener("click", () => ir(k)));
    g.querySelectorAll("[data-sn-galeria-paso]").forEach((b) => {
      b.addEventListener("click", () => ir(actual + Number(b.getAttribute("data-sn-galeria-paso"))));
    });
    g.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") { e.preventDefault(); ir(actual + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); ir(actual - 1); }
    });

    /* Deslizar con el dedo. touch-action:pan-y en el CSS deja el scroll
       vertical al navegador y nos entrega solo el gesto horizontal. */
    let x0 = null;
    escenario.addEventListener("pointerdown", (e) => { x0 = e.clientX; });
    escenario.addEventListener("pointerup", (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { ir(actual + (dx < 0 ? 1 : -1)); return; }
      /* Un toque (como en las historias): mitad derecha avanza, izquierda
         retrocede. Un scroll vertical dispara pointercancel, no llega aquí. */
      if (Math.abs(dx) < 10 && !e.target.closest("button")) {
        const r = escenario.getBoundingClientRect();
        ir(actual + (e.clientX > r.left + r.width / 2 ? 1 : -1));
      }
    });
    escenario.addEventListener("pointercancel", () => { x0 = null; });

    if (QUIETO) { if (pausa) pausa.hidden = true; return; }

    function estado() {
      g.classList.toggle("sn-galeria--detenida", Object.values(motivos).some(Boolean));
    }
    g.addEventListener("animationend", (e) => {
      if (e.animationName === "sn-progreso" && e.target.classList.contains("sn-activa")) ir(actual + 1);
    });
    if (pausa) {
      pausa.addEventListener("click", () => {
        motivos.boton = !motivos.boton;
        pausa.setAttribute("aria-pressed", motivos.boton ? "true" : "false");
        pausa.setAttribute("aria-label", motivos.boton ? "Reanudar el carrusel de fotos" : "Pausar el carrusel de fotos");
        const ip = pausa.querySelector(".sn-icono--pausa");
        const ir2 = pausa.querySelector(".sn-icono--play");
        if (ip) ip.hidden = motivos.boton;
        if (ir2) ir2.hidden = !motivos.boton;
        estado();
      });
    }
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      g.addEventListener("mouseenter", () => { motivos.puntero = true; estado(); });
      g.addEventListener("mouseleave", () => { motivos.puntero = false; estado(); });
    }
    g.addEventListener("focusin", () => { motivos.foco = true; estado(); });
    g.addEventListener("focusout", (e) => { if (!g.contains(e.relatedTarget)) { motivos.foco = false; estado(); } });
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((en) => { motivos.fuera = !en[0].isIntersecting; estado(); });
      io.observe(g);
      alLimpiar(() => io.disconnect());
    }

    /* Las otras cuatro fotos se descargan después del evento load: la primera
       es el LCP y no compite con nadie. */
    const arrancar = () => { g.classList.add("sn-galeria--viva", "sn-galeria--auto"); };
    if (document.readyState === "complete") arrancar();
    else {
      window.addEventListener("load", arrancar, { once: true });
      alLimpiar(() => window.removeEventListener("load", arrancar));
    }
  }

  /* ── Barra de stock: unidades_restantes / unidades_lote ──────────────
     La barra sale solo si #sn-ajustes trae un lote real (hoy null): sin él,
     media barra diría "ya se vendió la mitad", una cifra inventada. Se pinta
     quieta, sin animación: una barra que se vacía en cada visita escenifica
     ventas que no están pasando. */
  function stock() {
    const r = A.unidades_restantes;
    const l = A.unidades_lote;
    const valido = Number.isInteger(r) && Number.isInteger(l) && l > 0 && r >= 0 && r <= l;
    if (!valido) return;
    document.querySelectorAll("[data-sn-stock]").forEach((s) => {
      const barra = s.querySelector(".sn-stock__barra");
      if (!barra) return;
      s.style.setProperty("--sn-stock-nivel", Math.max(0.03, r / l).toFixed(3));
      barra.hidden = false;
    });
  }

  /* ── Revelado al entrar en pantalla ───────────────────────────────── */
  function revelar() {
    const els = document.querySelectorAll("[data-sn-rev]");
    if (QUIETO || !("IntersectionObserver" in window)) {
      els.forEach((e) => e.classList.add("sn-visto"));
      return;
    }
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add("sn-visto");
        io.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach((e) => io.observe(e));
    alLimpiar(() => io.disconnect());
  }

  /* ── Barra de compra fija ─────────────────────────────────────────────
     Entra cuando el botón principal del hero ya pasó HACIA ARRIBA (no cuando
     todavía no ha llegado), y se retira mientras se ve la oferta final: dos
     botones de compra en la misma pantalla se reparten el clic. */
  function barraFija() {
    const barra = document.querySelector("[data-sn-cta-fijo]");
    const centinela = document.querySelector("[data-sn-centinela-cta]");
    const botonHero = document.querySelector('[data-sn-origen="hero"]');
    const botonFinal = document.querySelector('[data-sn-origen="oferta"]');
    if (!barra || !centinela) return;
    /* Se mide la posición en cada frame de scroll. IntersectionObserver solo
       avisa cuando CAMBIA la intersección: un salto de scroll que pasa de
       "ya pasé el botón" a "todavía no llego" sin cruzarlo no dispara nada y
       la barra quedaba pegada tapando el precio. Un rect por frame es barato. */
    let pendiente = false;
    function medir() {
      pendiente = false;
      const alto = window.innerHeight;
      const pasado = centinela.getBoundingClientRect().top < 0;
      /* Copia §18: "a partir del primer scroll". En el navegador de WhatsApp
         el botón del hero puede quedar debajo del borde: si ya hubo scroll y
         sigue abajo, la barra entra. Nunca con el del hero a la vista. */
      const heroAbajo = !!botonHero && window.scrollY > 0 && botonHero.getBoundingClientRect().bottom > alto;
      /* Se retira cuando el botón final ya asomó por encima de la barra, no
         cuando empieza su sección: así no queda tramo sin botón de compra. */
      let enOferta = false;
      if (botonFinal) {
        const r = botonFinal.getBoundingClientRect();
        enOferta = r.top < alto - barra.offsetHeight && r.bottom > 0;
      }
      const ver = (pasado || heroAbajo) && !enOferta;
      barra.classList.toggle("sn-visible", ver);
      if (ver) barra.removeAttribute("inert"); else barra.setAttribute("inert", "");
    }
    const pedir = () => { if (!pendiente) { pendiente = true; requestAnimationFrame(medir); } };
    window.addEventListener("scroll", pedir, { passive: true });
    window.addEventListener("resize", pedir, { passive: true });
    alLimpiar(() => {
      window.removeEventListener("scroll", pedir);
      window.removeEventListener("resize", pedir);
    });
    medir();
  }

  /* ── Marquesina y cinta de fotos: pausa manual (WCAG 2.2.2) y fuera de
        pantalla. Las dos se mueven solas más de 5 segundos. ─────────────── */
  function movimientoConPausa(selPista, selBoton, etiquetas) {
    const pista = document.querySelector(selPista);
    const boton = document.querySelector(selBoton);
    if (!pista) return;
    if (QUIETO) { if (boton) boton.hidden = true; return; }
    if (boton) {
      boton.addEventListener("click", () => {
        const pausada = pista.classList.toggle("sn-pausada");
        boton.setAttribute("aria-pressed", pausada ? "true" : "false");
        boton.setAttribute("aria-label", pausada ? etiquetas[1] : etiquetas[0]);
        const ip = boton.querySelector(".sn-icono--pausa");
        const ir = boton.querySelector(".sn-icono--play");
        if (ip) ip.hidden = pausada;
        if (ir) ir.hidden = !pausada;
        pista.style.animationPlayState = "";
      });
    }
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((e) => {
        pista.style.animationPlayState = e[0].isIntersecting && !pista.classList.contains("sn-pausada") ? "" : "paused";
      });
      io.observe(pista);
      alLimpiar(() => io.disconnect());
    }
  }

  /* ── Testimonios: solo si hay reales en #sn-ajustes. textContent, nunca
        innerHTML: el texto viene de settings que edita una persona. ────── */
  function testimonios() {
    const lista = Array.isArray(A.testimonios) ? A.testimonios.filter((t) => t && t.texto && t.nombre) : [];
    const sec = document.querySelector("[data-sn-testimonios]");
    const ul = document.querySelector("[data-sn-testimonios-lista]");
    const tpl = document.getElementById("sn-tpl-testimonio");
    if (!lista.length || !sec || !ul || !tpl) return;
    lista.forEach((t) => {
      const li = tpl.content.firstElementChild.cloneNode(true);
      li.querySelector(".sn-testimonio__texto").textContent = t.texto;
      li.querySelector(".sn-testimonio__autor").textContent = t.nombre;
      ul.appendChild(li);
    });
    sec.hidden = false;
  }

  /* ── Medición ─────────────────────────────────────────────────────────
     Nombres de Shopify Web Pixels (los traduce el Custom Pixel):
       product_viewed → view_item → ViewContent, y así. */
  function medicion() {
    emitir("product_viewed", { valor: A.precio, moneda: A.moneda });
    const hitos = { 50: false, 90: false };
    window.addEventListener("scroll", () => {
      const alto = document.documentElement.scrollHeight - window.innerHeight;
      if (alto <= 0) return;
      const pct = (window.scrollY / alto) * 100;
      Object.keys(hitos).forEach((h) => {
        if (!hitos[h] && pct >= Number(h)) { hitos[h] = true; emitir("scroll_" + h); }
      });
    }, { passive: true });
    document.querySelectorAll("[data-sn-whatsapp]").forEach((a) => a.addEventListener("click", () => emitir("clic_whatsapp")));
  }

  function montar() {
    limpiezas.forEach((fn) => { try { fn(); } catch (e) { /* nodo ya retirado */ } });
    limpiezas = [];
    raiz = document.querySelector(".sn-lp");
    if (!raiz) return false;
    if (!QUIETO) raiz.classList.add("sn-mov");
    A = leerAjustes();
    pintarPromo();
    arrancarReloj();
    galeria();
    stock();
    revelar();
    barraFija();
    movimientoConPausa("[data-sn-marquesina]", "[data-sn-pausa]", ["Pausar el anuncio", "Reanudar el anuncio"]);
    movimientoConPausa("[data-sn-cinta-pista]", "[data-sn-cinta-pausa]", ["Pausar las fotos en movimiento", "Reanudar las fotos en movimiento"]);
    testimonios();
    return true;
  }

  /* La medición corre una sola vez por visita, no en cada repintado del editor. */
  function iniciar() { if (montar()) medicion(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector(".sn-lp")) montar();
  });
  document.addEventListener("shopify:section:unload", (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector(".sn-lp")) {
      limpiezas.forEach((fn) => { try { fn(); } catch (err) { /* nodo ya retirado */ } });
      limpiezas = [];
    }
  });
})();

/* ═══ assets/js/sn-carrito.js ═══ */
/* sn-carrito.js — "Comprar ahora": agrega la creatina y abre el pago de Shopify.
 *
 * Verificado contra shopify.dev (Cart AJAX API):
 *   GET  /cart.js     · el carrito actual, con "variant_id" en cada línea
 *   POST /cart/add.js · Content-Type: application/json
 *   { "items": [ { "id": <variant_id>, "quantity": 1 } ] }
 * No hay backend propio: el carrito y el checkout son de Shopify. Desde el
 * 03-10-2026, a pedido del cliente, el botón va directo a /checkout sin pasar
 * por la página del carrito, siempre que el pago vaya a cobrar justo lo que
 * dice el botón: 1 tarro y nada más. Si el carrito ya traía otras cosas de
 * una visita anterior, abre /cart para que el cliente las vea antes de pagar.
 * Las rutas salen de window.Shopify.routes.root
 * ("/" o "/en/" si la tienda activa idiomas o mercados con prefijo); en local
 * no existe y se usa "/".
 */
(function () {
  "use strict";

  const RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  let temporizador = 0;
  let borrado = 0;

  /* La región viva está siempre en el árbol (no hidden): una región que
     aparece ya con el texto no se anuncia de forma fiable, sobre todo en
     VoiceOver. Se vacía y se llena en el frame siguiente. */
  function avisar(texto) {
    /* Se busca en cada aviso: en el editor de temas la sección se vuelve a
       pintar y el nodo de la carga anterior ya no existe. */
    const aviso = document.querySelector("[data-sn-aviso]");
    if (!aviso) return;
    clearTimeout(temporizador);
    clearTimeout(borrado);
    aviso.textContent = "";
    requestAnimationFrame(() => {
      aviso.textContent = texto;
      aviso.classList.add("sn-aviso--visible");
    });
    temporizador = setTimeout(() => {
      aviso.classList.remove("sn-aviso--visible");
      borrado = setTimeout(() => { aviso.textContent = ""; }, 250);
    }, 4200);
  }

  function emitir(nombre, datos) {
    const detalle = datos || {};
    document.dispatchEvent(new CustomEvent("sn:" + nombre, { detail: detalle }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: nombre }, detalle));
  }

  function liberar(btn) {
    btn.removeAttribute("aria-busy");
    btn.removeAttribute("aria-disabled");
  }

  /* Un variant_id real son solo dígitos. Mientras el producto no exista en
     Shopify (paso 1 del blueprint) el botón lo dice, en vez de fallar mudo. */
  const esVariante = (id) => /^\d{6,}$/.test(String(id || ""));

  /* El carrito actual, o null si no se pudo leer. */
  function leerCarrito() {
    return fetch(RAIZ + "cart.js", { headers: { Accept: "application/json" }, cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((c) => (c && Array.isArray(c.items) ? c.items : null))
      .catch(() => null);
  }

  /* Decide qué hacer según lo que ya hay en el carrito:
     - vacío: agrega 1 tarro y abre el pago.
     - solo la creatina, 1 tarro (el cliente fue al pago, volvió con "atrás" y
       pulsa otra vez): abre el pago sin sumar otro.
     - cualquier otra cosa (otros productos, varios tarros, o no se pudo leer):
       el pago no cobraría lo que dice el botón. Se asegura la creatina y se
       abre el carrito, donde el cliente ve y ajusta todo. */
  function comprar(id) {
    return leerCarrito().then((lineas) => {
      const propia = lineas && lineas.find((l) => String(l.variant_id) === String(id));
      const limpio = lineas !== null && (lineas.length === 0 || (lineas.length === 1 && propia && propia.quantity === 1));
      const destino = limpio ? "checkout" : "cart";
      return (propia ? Promise.resolve() : agregar(id)).then(() => destino);
    });
  }

  function agregar(id) {
    return fetch(RAIZ + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      /* Si Shopify rechaza (agotado, sin stock suficiente), su respuesta trae
         la razón en "description", ya en el idioma de la tienda. */
      .then((r) => {
        if (r.ok) return r.json().catch(() => ({}));
        return r.json().catch(() => ({})).then((j) => {
          const error = new Error(j.description || "");
          error.deShopify = true;
          throw error;
        });
      });
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-sn-add]");
    if (!btn) return;
    const id = btn.getAttribute("data-sn-variant-id");
    const origen = btn.getAttribute("data-sn-origen") || "";

    if (!esVariante(id)) {
      avisar("Vista previa: la compra se activa cuando el producto exista en Shopify.");
      emitir("add_to_cart_bloqueado", { origen: origen, motivo: "sin_variant_id" });
      return;
    }
    if (btn.getAttribute("aria-busy") === "true") return;

    /* aria-disabled y no disabled: disabled en el botón con foco manda el
       foco al body, y si falla no vuelve. */
    btn.setAttribute("aria-busy", "true");
    btn.setAttribute("aria-disabled", "true");
    emitir("product_added_to_cart", { origen: origen, variant_id: id });

    comprar(id)
      .then((destino) => {
        /* No se emite checkout_started aquí: ese evento lo dispara Shopify
           Web Pixels cuando el pago de verdad se abre; emitirlo antes lo
           duplicaría en el embudo. */
        window.location.href = RAIZ + destino;
      })
      .catch((err) => {
        liberar(btn);
        /* Solo se muestra el texto de Shopify (agotado, sin stock). Los
           errores del navegador ("Failed to fetch", "Load failed") vienen en
           inglés y no le dicen nada al comprador. */
        avisar((err && err.deShopify && err.message) || "No pudimos abrir el pago. Intenta de nuevo o escríbenos por WhatsApp.");
      });
  });

  /* Al volver desde el pago con "atrás", el navegador puede restaurar la
     página desde su caché (bfcache) con el botón todavía ocupado, y un botón
     ocupado ignora los clics. */
  window.addEventListener("pageshow", (e) => {
    if (!e.persisted) return;
    document.querySelectorAll("[data-sn-add][aria-busy]").forEach(liberar);
  });
})();
